import { Image, Label, TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutPartialShipmentPlanningProfileList } from "./autogen/AutogenLayoutPartialShipmentPlanningProfileList";
import { StringUtil } from "@mcleod/core";

export class PartialShipmentPlanningProfileList extends AutogenLayoutPartialShipmentPlanningProfileList {

    override onLoad() {
        this.mainDataSource.search();
    }

    tableManifestProfileOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const imageProfileColor = tableRow.findComponentById("imageProfileColor") as Image;
        const labelProfileDescription = tableRow.findComponentById("labelDescription") as Label;
        const description = tableRow.data?.getString("descr");
        labelProfileDescription.text = StringUtil.isEmptyString(description) ? "---" : description;
        if (imageProfileColor != null) {
            const profileColor = tableRow.data?.getString("profile_color", null);
            imageProfileColor.color = profileColor;
            imageProfileColor.visible = profileColor != null;
        }
    }

}
